import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { baseURL, getComments, getCommentsReply } from "../redux/Action";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  IoIosArrowDropdownCircle,
  IoIosArrowDropupCircle,
} from "react-icons/io";
import Replies from "./Replies";
import ReplyInput from "./ReplyInput";
import CommentCard from "./CommentCard";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Comments = ({ id }) => {
  const {
    commentLoading,
    commentError,
    comments,
    user,
    isAuth,
    replies,
    token,
    replyError,
    replyLoading,
  } = useSelector((state) => state);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [reply, setReply] = useState(false);
  const [replyInd, setReplyInd] = useState(-1);
  const [comment, setComment] = useState("");
  const [showReplies, setShowReplies] = useState(false);

  useEffect(() => {
    getComments(dispatch, id);
  }, []);

  const deleteComment = (_id, el) => {
    console.log(el);
    const toastId = toast.loading("Deleting...", { theme: "dark" });
    axios
      .delete(`${baseURL}/comments/${_id}`, {
        withCredentials: true,
        headers: {
          Authorization: token,
        },
      })
      .then((res) => {
        toast.update(toastId, {
          render: "Deleted Successfully",
          type: "success",
          isLoading: false,
          theme: "dark",
          autoClose: 2000,
          closeOnClick: true,
        });
        getComments(dispatch, id);
        getCommentsReply(dispatch, el);
      })
      .catch((err) => {
        toast.update(toastId, {
          render: "Something went wrong",
          type: "error",
          isLoading: false,
          autoClose: 2000,
          closeOnClick: true,
        });
      });
  };

  const handleReply = (i) => {
    if (!isAuth) {
      navigate("/login");
    }
    setReplyInd(i);
    setReply(!reply);
  };

  const handleSubmit = (el) => {
    const payload = {
      user_id: user.user._id,
      blog_id: id,
      message: comment,
      rating: 0,
      parentId: el._id,
    };
    const toastId = toast.loading("Commenting...", { theme: "dark" });
    axios
      .post(`${baseURL}/comments`, payload, {
        withCredentials: true,
        headers: {
          Authorization: token,
        },
      })
      .then((res) => {
        toast.update(toastId, {
          render: "Commented",
          type: "success",
          isLoading: false,
          theme: "dark",
          autoClose: 2000,
          closeOnClick: true,
        });
        getCommentsReply(dispatch, el._id);
        setComment("");
        setReply(!reply);
      })
      .catch((err) => {
        toast.update(toastId, {
          render: "Something went wrong",
          type: "error",
          isLoading: false,
          autoClose: 2000,
          closeOnClick: true,
        });
      });
  };

  const getRepliesToShow = (el, i) => {
    setReplyInd(i);
    setShowReplies(!showReplies);
    !showReplies && getCommentsReply(dispatch, el._id);
  };

  return (
    <>
      {commentLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            marginTop: "20px",
          }}
        >
          <CircularProgress />
        </Box>
      ) : commentError ? (
        <Stack sx={{ width: "60%", margin: "2rem auto" }} spacing={2}>
          <Alert severity="error">
            Something went wrong while fetching comments.
          </Alert>
        </Stack>
      ) : (
        comments.map((c, i) => {
          return (
            <div
              key={i}
              className="my-4  border-b border-gray-200 dark:border-gray-600 py-2 px-4"
            >
              <CommentCard
                handleReply={handleReply}
                deleteComment={deleteComment}
                el={c}
                i={i}
                id={id}
                user={user}
              />

              {reply && i === replyInd && (
                <>
                  <ReplyInput
                    el={c}
                    handleSubmit={handleSubmit}
                    comment={comment}
                    reply={reply}
                    setComment={setComment}
                    setReply={setReply}
                    user={user}
                  />
                </>
              )}

              <p
                className="cursor-pointer font-bold mt-2 flex items-center dark:text-white"
                onClick={() => getRepliesToShow(c, i)}
              >
                {showReplies && i === replyInd ? (
                  <IoIosArrowDropupCircle className="text-xl dark:text-white mr-2" />
                ) : (
                  <IoIosArrowDropdownCircle className="text-xl dark:text-white mr-2" />
                )}
                View Replies
              </p>

              {replyLoading && i === replyInd ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "20px",
                  }}
                >
                  <CircularProgress />
                </Box>
              ) : replyError && i === replyInd ? (
                <Stack sx={{ width: "60%", margin: "2rem auto" }} spacing={2}>
                  <Alert severity="error">
                    Something went wrong while fetching data.
                  </Alert>
                </Stack>
              ) : (
                <>
                  {showReplies && replies.length === 0 && i === replyInd && (
                    <p className="dark:text-white my-2 px-4">No replies!</p>
                  )}

                  {showReplies &&
                    i === replyInd &&
                    replies.map((el, i) => {
                      return (
                        <Replies
                          key={i}
                          i={i}
                          parent={c}
                          el={el}
                          deleteComment={deleteComment}
                          user={user}
                        />
                      );
                    })}
                </>
              )}
            </div>
          );
        })
      )}
    </>
  );
};

export default Comments;
